import { createContext, useContext, ReactNode } from "react";
import { useVisitorTracking, VisitorContext } from "@/hooks/useVisitorTracking";

const VisitorTrackingContext = createContext<VisitorContext | null>(null);

export function VisitorTrackingProvider({ children }: { children: ReactNode }) {
  const ctx = useVisitorTracking();
  return (
    <VisitorTrackingContext.Provider value={ctx}>
      {children}
    </VisitorTrackingContext.Provider>
  );
}

export function useVisitorContext(): VisitorContext {
  const ctx = useContext(VisitorTrackingContext);
  if (!ctx) {
    return {
      visitorCookieId: null,
      landingPage: null,
      utmSource: null,
      utmCampaign: null,
      utmMedium: null,
      pagesViewed: [],
      persona: null,
      setPersona: () => {},
      trackEvent: () => {},
      updateProfile: () => {},
      profile: {},
      personalisation: null,
      personalisationLoading: false,
      triggerPersonalisation: async () => ({ ok: false, reason: "no_context" }),
      dynamicMode: false,
      setDynamicMode: () => {},
      ensureVisitorSession: async () => null,
      pipelineStatus: null,
      setPipelineStatus: () => {},
      hasPendingTc: false,
      discardPendingTc: () => {},
    };
  }
  return ctx;
}
